import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-payment-confirmation',
  template: '',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      html:has(iframe) {
        body {
          display: none;
        }
      }
    `,
  ],
})
export class PaymentConfirmationComponent implements OnInit, OnDestroy {
  private onDestroy$: Subject<any> = new Subject();

  ngOnInit() {}
  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.complete();
  }
}
